import * as RotateObjectActionMetadataKeys from 'automation-ui-action-features/actions/rotate-object/RotateObjectActionMetadataKeys';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as InternalPropertyDefaults from 'automation-ui-action-features/object-type-properties/InternalPropertyDefaults';
import { Record } from 'immutable';
import { buildRoutingRules } from 'routing-ui/routing-rules/utils/buildRoutingRules';
export default class RotateObjectActionMetadata extends Record({
  [RotateObjectActionMetadataKeys.ACTION_TYPE]: ActionTypes.ROTATE_OBJECT,
  [RotateObjectActionMetadataKeys.USER_IDS]: [],
  [RotateObjectActionMetadataKeys.TEAM_IDS]: [],
  [RotateObjectActionMetadataKeys.TARGET_PROPERTY]: InternalPropertyDefaults.HUBSPOT_OWNER,
  [RotateObjectActionMetadataKeys.OVERWRITE_CURRENT_OWNER]: false,
  [RotateObjectActionMetadataKeys.ROUTING_RULE_DEFINITION]: null
}, 'RotateObjectActionMetadata') {
  getOverwriteCurrentOwner() {
    return this[RotateObjectActionMetadataKeys.OVERWRITE_CURRENT_OWNER];
  }
  setOverwriteCurrentOwner(isSet) {
    return this.set(RotateObjectActionMetadataKeys.OVERWRITE_CURRENT_OWNER, isSet);
  }
  getTargetProperty() {
    return this[RotateObjectActionMetadataKeys.TARGET_PROPERTY];
  }
  setTargetProperty(targetProperty) {
    return this.set(RotateObjectActionMetadataKeys.TARGET_PROPERTY, targetProperty);
  }
  clearAssignments() {
    // NOTE(bheng): Normally I would use this.merge, but there's some weird
    //   behavior where it turns arrays into Lists.
    return this.setTeamIds([]).setUserIds([]);
  }
  getTeamIds() {
    return this[RotateObjectActionMetadataKeys.TEAM_IDS] || [];
  }
  setTeamIds(teamIds) {
    return this.set(RotateObjectActionMetadataKeys.TEAM_IDS, teamIds);
  }
  getUserIds() {
    return this[RotateObjectActionMetadataKeys.USER_IDS];
  }
  setUserIds(userIds) {
    return this.set(RotateObjectActionMetadataKeys.USER_IDS, userIds);
  }
  getRoutingRuleDefinition() {
    return this[RotateObjectActionMetadataKeys.ROUTING_RULE_DEFINITION];
  }
  setRoutingRuleDefinition(routingRuleDefinition) {
    return this.set(RotateObjectActionMetadataKeys.ROUTING_RULE_DEFINITION, buildRoutingRules(routingRuleDefinition));
  }
}